import React from 'react';
import type { Candidate, CandidateRedux } from '@axiom/validation';
import {
  Well,
  Paragraph,
  ParagraphHeader,
  useApi,
  Layout,
  LayoutItem,
  Banner,
  CandidateAccolades,
  CandidatePerformanceFeedback,
} from '@axiom/ui';

import { CandidateApi } from '../../api/candidate-api';
import NoReputationSvg from '../../public/svg/no-talent-reputation.svg';

export interface CandidateReputationSectionProps {
  candidate: CandidateRedux | Candidate;
  name: string;
}

export const CandidateReputationSection = ({
  candidate,
  name,
}: CandidateReputationSectionProps) => {
  const [{ data: candidateReputation }] = useApi(
    CandidateApi.readCandidateReputation({ candidateId: candidate.id })
  );
  return (
    <Layout verticalGutter="24px" direction="vertical" name={name}>
      <CandidateAccolades candidateReputation={candidateReputation} />
      {candidate.showReputation === false && (
        <Banner name="optedOutBanner" impact="high" type="critical">
          <ParagraphHeader as="span">Talent Opted Out.</ParagraphHeader> This
          talent has opted out of displaying client feedback.
        </Banner>
      )}

      {candidateReputation?.displayableSurveyScoreData ? (
        <CandidatePerformanceFeedback
          stacked
          candidateReputation={candidateReputation}
        />
      ) : (
        <Well background="light blue" name="limitedFeedbackDisplay">
          <Layout horizontalGutter="16px" position="middle">
            <LayoutItem>
              <NoReputationSvg width="98" height="93" />
            </LayoutItem>
            <Paragraph>
              While this talent does not have enough formal client feedback yet,
              we are confident in their skills and believe they are a good match
              for your opportunity.
            </Paragraph>
          </Layout>
        </Well>
      )}
    </Layout>
  );
};
